export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
export const UAE_PHONE_CODE = 'QA'

export const INBOUND_TRANSLATE_HASH = {
  header: 'inbound.personal_information.header',
  firstName: 'inbound_travelers_add_first_name',
  familyName: 'inbound_travelers_add_last_name',
  birthdate: 'inbound_dob_date',
  nationality: 'inbound_nationality_nationality',
  contacts: 'inbound.contacts.title',
  email: 'inbound_travelers_add_email',
}

export const OUTBOUND_TRANSLATE_HASH = {
  header: 'outbound.personal_information.header',
  firstName: 'outbound.travelers.first_name',
  familyName: 'outbound.travelers.last_name',
  birthdate: 'outbound_dob_date',
  nationality: 'outbound_nationality_nationality',
  contacts: 'outbound.contacts.title',
  email: 'outbound.travelers.email',
}
